import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _toConsumableArray from "/app/node_modules/babel-runtime/helpers/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateOption from './date-option';

export default {
    components: { DateOption: DateOption },
    props: [],
    data: function data() {
        var stateBossList = this.$store.state["master-data"].bossList;

        return {
            bossList: [{ IdBoss: "ALL", Boss: "Todos los jefes" }].concat(_toConsumableArray(stateBossList)), // IdBoss: number, Boss: string
            pendingCurrentBoss: "ALL",
            pendingInitDate: null,
            pendingEndDate: null
        };
    },

    methods: {
        dateOptionSelected: function dateOptionSelected(_ref) {
            var sinceDate = _ref.sinceDate,
                toDate = _ref.toDate;

            this.pendingInitDate = sinceDate;
            this.pendingEndDate = toDate;
        },
        closeEmit: function closeEmit() {
            this.$emit('close');
        },
        exportPendingTable: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _this = this;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(this.$isAdmin() || this.$isBoss())) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return this.$store.dispatch('dashboard/table/exportPendingTable', {
                                    idBoss: this.$isAdmin() || this.$isAdminCollaborator() ? this.pendingCurrentBoss === "ALL" ? null : this.pendingCurrentBoss : this.$store.state.user.userId, // this.$isBoss() ? currentBossId : bossesId or ALL
                                    startDate: this.pendingInitDate,
                                    endDate: this.pendingEndDate
                                });

                            case 3:
                                ;
                                this.closeEmit();
                                this.$nextTick(function () {
                                    return _this.$refs.dateOptionAdmin.clear();
                                });

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function exportPendingTable() {
                return _ref2.apply(this, arguments);
            }

            return exportPendingTable;
        }()
    },
    computed: {
        exportButtonDisabled: function exportButtonDisabled() {
            return !this.pendingInitDate && !this.pendingEndDate;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/btn-without-cc.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/btn-without-cc.vue
// module chunks = 0 5